<template>
    <v-row no-gutters class="pa-3">
        <v-col cols="12" class="pb-2">
            <h1>Rapprochements bancaires</h1>
        </v-col>

        <v-col cols="12">
            <oss-data-table
                :headers="headers"
                :items="items"
                :striped="true"
                :dense="true"
                :loading="loading"
            >
                <template v-slot:item="{ item }">
                    <tr class="bankLine" :key="item.id" @click="addRemoveItemExpanded(item)">
                        <td class="text-center" width="64px">
                            <v-icon>
                                {{ isItemExpanded(item) ? "$fa-chevron-down" : "$fa-chevron-up" }}
                            </v-icon>
                        </td>
                        <td class="text-left pl-4">
                            <strong>{{ item.name }}</strong>
                        </td>

                        <td class="text-left pl-4">
                            <strong>{{ item.iban || "" }}</strong>
                        </td>

                        <!-- <td class="text-left" cols="2">
                            <strong>Solde relevé : {{ newCommonFormatCurrency(item.importedBalance, undefined) }}</strong>
                        </td>
                        <td class="text-left" cols="2">
                            <strong>Solde comptable : {{ newCommonFormatCurrency(item.generalLedgerBalance, undefined) }}</strong>
                        </td> -->
                        <td class="text-right pr-10">
                            <strong>
                                &#xc9;cart :
                                {{ newCommonFormatCurrency(item.balanceReconciliation, undefined) }}
                            </strong>
                        </td>
                    </tr>
                    <tr v-if="isItemExpanded(item)">
                        <td
                            :colspan="6"
                            style="padding: 0; background: #f4f4f4"
                            class="pa-2"
                            :key="refreshKey"
                        >
                            <oss-data-table
                                :headers="headersExtendeTable"
                                :items="item.balances"
                                :striped="true"
                                :dense="true"
                                :height="'calc(100vh - 350px)'"
                                :displayRowNumber="true"
                            >
                                <template v-slot:item="{ item: balance, index: balanceIndex }">
                                    <tr @click.stop="addRemoveItemExpanded(balance.selected)">
                                        <td />
                                        <td>{{ formatDate(balance.date) }}</td>
                                        <td>
                                            <v-select-filled
                                                v-model="balance.selected"
                                                :items="balance.balances"
                                                :item-title="getBalanceTypeText"
                                                return-object
                                                outlined
                                                hide-details
                                                @update:model-value="
                                                    selectedBalanceChanged(balance)
                                                "
                                                :readonly="balance.balances.length === 1"
                                                v-if="
                                                    balance.balances && balance.balances.length > 1
                                                "
                                                density="compact"
                                            />
                                            <div v-else-if="balance.balances.length === 1">
                                                {{ getBalanceTypeText(balance.selected) }}
                                            </div>
                                        </td>

                                        <!--  ** balance -->
                                        <td class="text-right">
                                            {{
                                                newCommonFormatCurrency(
                                                    balance.selected.balance,
                                                    undefined,
                                                )
                                            }}
                                        </td>

                                        <!-- ** glBalance -->
                                        <td>
                                            <div class="text-right">
                                                {{
                                                    newCommonFormatCurrency(
                                                        balance.glBalance,
                                                        undefined,
                                                    )
                                                }}
                                            </div>
                                        </td>

                                        <!-- ** difference - Différence -->
                                        <td>
                                            <div
                                                v-if="balance.selected.balance"
                                                class="text-right"
                                                :style="
                                                    differenceColor(
                                                        balance.selected.balance,
                                                        balance.glBalance,
                                                    )
                                                "
                                            >
                                                <strong>
                                                    {{
                                                        difference(
                                                            balance.selected.balance,
                                                            balance.glBalance,
                                                        )
                                                    }}
                                                </strong>
                                            </div>

                                            <div v-else class="text-right">-</div>
                                        </td>

                                        <!-- ** deltaPreviousMonth - Écart M-1 -->
                                        <!-- <td>
                                            <div
                                                class="text-right"
                                                :style="deltaPreviousMonth(item.balances, balanceIndex)"
                                            >
                                                <strong>
                                                    {{ deltaPreviousMonth(item.balances, balanceIndex) }}
                                                </strong>
                                            </div>
                                        </td> -->
                                        <td align="end">
                                            <!-- <v-menu offset-y v-if="!isDuplicate(balance.selected, item)"> -->
                                            <v-menu offset-y>
                                                <template v-slot:activator="{ props }">
                                                    <v-btn-icon
                                                        icon="$dots_vertical"
                                                        v-bind="props"
                                                    />
                                                </template>
                                                <v-list>
                                                    <v-list-item
                                                        v-if="balanceIndex"
                                                        @click="showBTs(item, balanceIndex)"
                                                    >
                                                        <v-list-item-title>
                                                            Afficher
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                    <v-list-item
                                                        @click="deleteBalance(item, balanceIndex)"
                                                    >
                                                        <v-list-item-title>
                                                            Supprimer
                                                        </v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:body.append>
                                    <tr style="background: #fff">
                                        <td />
                                        <td>
                                            <oss-date-picker-filled
                                                v-model="item.newBalanceDate"
                                                :minDate="accountingPeriod.start"
                                                :maxDate="accountingPeriod.end"
                                                hide-details
                                                @change-date="onNewBalanceDateChanged($event)"
                                            />
                                        </td>
                                        <td>
                                            <oss-text-field-filled
                                                outlined
                                                dense
                                                hide-details
                                                v-model="item.newBalance"
                                            />
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                size="small"
                                                rounded
                                                :disabled="disabledNewBalance(item)"
                                                :loading="upsertBABLoading"
                                                elevation="0"
                                                dark
                                                color="primary"
                                                @click="addNewBalance(item)"
                                                icon="$add"
                                            >
                                                Ajouter
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                            </oss-data-table>
                        </td>
                    </tr>
                </template>
            </oss-data-table>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import gql from "graphql-tag";

import moment from "moment-timezone";
import { State2Way } from "@/decorators";

import { Apollo } from "@/decorators";

import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import CREATE_BANK_ACCOUNT_BALANCE from "../../graphql/bankAccountBalance/UpsertBankAccountBalance.gql";
import SET_USE_BANK_ACCOUNT_BALANCE from "../../graphql/bankAccountBalance/SetUseBankAccountBalance.gql";
import DELETE_BANK_ACCOUNT_BALANCE from "../../graphql/bankAccountBalance/DeleteBankAccountBalance.gql";

import OssDataTable from "../ossComponents/ossDataTable2.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { getDBFormattedStartDate } from "@/services/dateServices";

@Component({
    components: {
        OssDataTable,
    },
})
export class CheckBankAccountBalance extends Vue {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) readonly companyId!: string;

    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    accountingPeriod: any;

    loading: boolean = false;

    // newBankAccountBalance = {
    //     newBalanceDate: null,
    //     newBalance: null,
    // };

    refreshKey = 0;

    formatDate(date) {
        if (!date) return "";
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    headersExtendeTable: any = [
        { text: "", value: "", width: "64px" },
        { text: "Date", value: "date" },
        { text: "Origine", value: "type" },
        { text: "Solde Relevé", value: "balance" },
        { text: "Solde Compta", value: "glBalance", align: "end" },
        { text: "Différence", value: "difference", align: "end" },
        // { text: "Écart M-1", value: "deltaPreviousMonth", align: "end" },
        { text: "", value: "actions", align: "end" },
    ];

    headers: any = [
        { title: "", value: "", width: "64px" },
        { title: "Compte", value: "bankAccount.name" },
    ];

    get accountingPeriodId() {
        // if (this.$route.params.accountingPeriodId) return this.$route.params.accountingPeriodId;
        if (this.accountingPeriod) return this.accountingPeriod.id;
        return "";
    }

    computeAccountingPeriodText(accountingPeriod) {
        let text = moment(accountingPeriod.start).format("DD-MM-YYYY");
        text += " / ";
        text += moment(accountingPeriod.end).format("DD-MM-YYYY");
        return text;
    }

    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            this.loading = true;
            return {
                companyId: this.companyId,
                auditCheck: "CheckBankAccountBalance",
                auditCheckKey: "vOPP8PD6xQ4q6hcNRx2f2GUo0",
                accountingPeriodId: this.accountingPeriodId,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                console.log("data", data);
                if (
                    data &&
                    data.auditItems &&
                    data.auditItems.items &&
                    data.auditItems.items.length
                ) {
                    const items = JSON.parse(JSON.stringify(data.auditItems.items));
                    for (const bankAccount of items) {
                        for (const item of bankAccount.balances) {
                            item.newBalanceDate = "";
                            item.newBalance = 0.0;
                            if (!item.balances?.length) {
                                item.selected = {};
                            } else if (item.balances.length === 1) {
                                item.selected = item.balances[0];
                            } else {
                                item.selected =
                                    item.balances.find((ba: any) => ba.use) || item.balances[0];
                            }
                        }
                    }
                    this.items = items;
                } else {
                    this.items = [];
                }
                console.log("data2", data);
                this.loading = false;
            }
        },
    })
    items: Array<any> = [];

    itemExpanded = [];

    isItemExpanded(item) {
        const index = this.itemExpanded.indexOf(item.id);
        return index !== -1;
    }

    addRemoveItemExpanded(item) {
        if (!item) {
            return;
        }
        const index = this.itemExpanded.indexOf(item.id);
        if (index === -1) {
            this.itemExpanded.push(item.id);
        } else {
            this.itemExpanded.splice(index, 1);
        }
    }

    // onNewBalanceDateChanged(date) {
    //     this.newBankAccountBalance.newBalanceDate = date;
    // }

    disabledNewBalance(bankAccount) {
        if (!bankAccount.newBalanceDate) return true;
        const newBalanceDate = moment(bankAccount.newBalanceDate);
        const balanceData = bankAccount.balances.find((b) => moment(b.date).isSame(newBalanceDate));
        if (balanceData?.balances?.length) {
            return !!balanceData.balances.find((b) => b.type === "MANUAL");
        }
        return false;
    }

    async deleteBalance(bankAccount, i) {
        const balanceData = bankAccount.balances[i];
        for (const balance of balanceData.balances) {
            await this.$apollo.mutate({
                mutation: DELETE_BANK_ACCOUNT_BALANCE,
                variables: {
                    id: balance.id,
                },
            });
        }
        bankAccount.balances.splice(i, 1);
    }

    async addNewBalance(item) {
        item.balances.push({
            date: item.newBalanceDate,
            balance: item.newBalance,
        });
        await this.updateItemData(item);
        item.newBalance = 0;
    }

    upsertBABLoading: boolean = true;
    async updateItemData(item) {
        this.upsertBABLoading = true;
        await this.$apollo.mutate({
            mutation: CREATE_BANK_ACCOUNT_BALANCE,
            variables: {
                baId: item.id,
                balance: {
                    date: getDBFormattedStartDate(item.newBalanceDate),
                    balance: item.newBalance,
                },
            },
        });
        this.upsertBABLoading = false;

        this.refresh();
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        } else {
            debugger;
        }
    }

    showBTs(bankAccount, balanceIndex) {
        if (balanceIndex) {
            const balance = bankAccount.balances[balanceIndex];
            const previousBalance = bankAccount.balances[balanceIndex - 1];
            const endDate = moment(previousBalance.date).add(1, "days");

            if (bankAccount.id && balance.date && endDate) {
                const params: any = {
                    bankAccountId: bankAccount.id,
                    beginDate: balance.date,
                    endDate,
                };

                this.$router.push({
                    name: "bank",
                    params,
                });
            }
        }
    }

    difference(balance, glBalance) {
        if (glBalance === undefined || glBalance === null) {
            debugger; // may not be empty
            return "-";
        }
        if (balance === undefined || balance === null) return "-";
        const diff = balance - glBalance;
        if (Math.abs(diff) < 1e-2) {
            return newCommonFormatCurrency(0);
        }
        return newCommonFormatCurrency(diff);
    }

    getDuplicated(item, bal) {
        return item.balances.filter(
            (ba) => moment(ba.date).isSame(moment(bal.date)) && ba.id !== bal.id,
        );
    }

    differenceColor(balance, glBalance) {
        if (balance === undefined) return "color:red;";
        if (glBalance === undefined) return "color:red;";
        if (Math.abs(balance - glBalance) > 1e-2) return "color:red;";
        return "color:green;";
    }

    // deltaPreviousMonth(balances, i) {
    //     if (i === 0) {
    //         return "-";
    //     }
    //     const difference = balances[i].selected.balance - balances[i].glBalance;
    //     const pmDifference = balances[i - 1].selected.balance - balances[i - 1].glBalance;
    //     return this.difference(difference, pmDifference);
    // }

    computeBalancesLoading = false;

    setBalance(balance, balanceIndex, bab) {
        balance[balanceIndex] = bab;
        this.refreshKey++;
    }

    getBalanceTypeText(item) {
        switch (item.type) {
            case "BUDGET_INSIGHT":
                return "Import automatique";
            case "EBICS_JE_DECLARE":
                return "EBICS JE Declare";
            case "EBICS_SO_BANK":
                return "EBICS SO Bank";
            case "EBICS_MANUAL":
                return "EBICS Manual";
            case "BANK_STATEMENT":
                return "Relevé bancaire (pdf)";
            case "MANUAL":
                return "Manuel";
            case "IMPORT_TXT":
                return "Relevé bancaire (texte)";
            case "IMPORT_FEC":
                return "Import fichier comptable";
            case "COMPUTE_CARRY_FORWARD":
                return "AN";
        }
        debugger; // git-ignore
        return "XXX";
    }

    async selectedBalanceChanged(balance) {
        this.$apollo.mutate({
            mutation: SET_USE_BANK_ACCOUNT_BALANCE,
            variables: {
                balanceId: balance.selected.id,
            },
        });
        this.refresh();
    }
}

export default toNative(CheckBankAccountBalance);
</script>

<style scoped>
.bankLine {
    background: #fff;
    transition: background 0.3s;
}

.bankLine:hover {
    background: #ffe8b5 !important;
}
</style>
